import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Stack,
  CircularProgress,
  Divider,
} from "@mui/material";
import { GradientButton } from "./index";

export const ResentLoginLinkBlock = ({
  email,
  isLoading,
  resentHandler,
  backHandler,
}: {
  email: string;
  isLoading: boolean;
  resentHandler: () => void;
  backHandler: () => void;
}) => {
  const [isTimeout, setIsTimeout] = useState<boolean>(true);
  const [time, setTime] = useState<number>(60);

  useEffect(() => {
    let id: NodeJS.Timeout;

    if (isTimeout) {
      id = setInterval(
        () =>
          setTime((num) => {
            if (num === 1) {
              setIsTimeout(false);
              clearTimeout(id);
              return 60;
            }
            return num - 1;
          }),
        1000,
      );
    }

    return () => clearTimeout(id);
  }, [isTimeout]);

  const sentHandler = () => {
    setIsTimeout(true);
    setTime(60);
    resentHandler();
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="calc(100vh - 74px)"
    >
      <Stack width="372px" gap="32px">
        <Stack gap={1}>
          <Typography variant="h1" component="h1" textAlign="left">
            Check your inbox
          </Typography>
          <Typography
            variant="subtitle1"
            color="#4C545B"
            textAlign="left"
            fontWeight={400}
          >
            A temporary login link has been sent to{" "}
            <span
              style={{
                fontWeight: 500,
                overflowWrap: "anywhere",
                whiteSpace: "normal",
              }}
            >
              {email}.
            </span>{" "}
            It’s valid for 15 minutes. Use it to access the platform.
          </Typography>
        </Stack>

        <Divider />
        <Typography
          variant="subtitle1"
          color="#4C545B"
          textAlign="left"
          fontWeight={400}
        >
          Didn’t receive the email? Check your spam folder or try again
          {isTimeout ? ` in ${time}sec...` : "."}
        </Typography>

        <Stack gap="8px" alignItems="flex-start">
          <GradientButton
            fullWidth
            disabled={isTimeout || isLoading}
            onClick={sentHandler}
            startIcon={
              isLoading && <CircularProgress size={20} color="inherit" />
            }
          >
            Resend link
          </GradientButton>
          <Typography variant="body1" color="#4C545B" fontWeight={500}>
            Back to{" "}
            <Box
              component="span"
              onClick={backHandler}
              sx={{
                fontWeight: 500,
                color: "#000000DE",
                "&:hover": { color: "#2194D2" },
                cursor: "pointer",
              }}
            >
              Sign in
            </Box>
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
